var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.25 2.25)",
    stroke: "#D2D2D9",
    strokeWidth: 2.7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.304 106.435h25.044M0 68.87h68.87M50.087 87.652v9.391a9.391 9.391 0 0 1-9.391 9.392"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.217 56.348V6.26A6.26 6.26 0 0 0 118.957 0H6.26A6.26 6.26 0 0 0 0 6.26v75.131a6.26 6.26 0 0 0 6.26 6.261h50.088"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EEF0F3",
    cx: 106.435,
    cy: 106.435,
    r: 37.565
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.957 106.435h-12.522V87.652"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorClock);
export default __webpack_public_path__ + "static/media/monitor-clock.cf130611.svg";
export { ForwardRef as ReactComponent };